import { StyledDialogTitle } from "../common/StyledDialogTitle";
import Box from "@mui/material/Box";
import {
  Divider,
  FormControl,
  Menu,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useState, useEffect } from "react";
import { get_expense_category } from "../../features/expense/expenseCategoryService";
import AppButton from "../common/AppButton";
import CommonInputField from "../common/InputField/CommonInputField";

interface IProps {
  anchorEl: any;
  handleClose: () => void;
  handleFilterSearch: () => void;
  nameInput: string;
  categoryInput: string;
  setNameInput: any;
  handleCategorySearch: (event: any) => void;
}

const ExpenseFilterModal = ({
  anchorEl,
  handleClose,
  handleFilterSearch,
  nameInput,
  setNameInput,
  handleCategorySearch,
}: IProps) => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [catData, setCatData] = useState<[]>([]);
  const handleChange = (field: string, value: string) => {
    if (field === "selectedCategory") {
      setSelectedCategory(value);
      handleCategorySearch(value);
    }
  };
  const getCategory = async () => {
    try {
      setIsLoading(true);
      const res = await get_expense_category({ page: 1, limit: 1000 });
      setCatData(res?.data.expense_categories || []);
    } catch (error: any) {
      alert(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCategory();
  }, []);

  return (
    <Box>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "460px",
          },
        }}
      >
        <StyledDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          isDone={false}
        >
          {"Filter Search"}
        </StyledDialogTitle>
        <Divider />
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 1,
            p: 1,
          }}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            px: 2,
            pt: 1,
            pb: 1,
          }}
        >
          {/* Search Name Input */}
          <Box sx={{ minWidth: "200px" }}>
            <CommonInputField
              label="Search Name"
              required
              placeholder="Search by Name"
              value={nameInput}
              onChange={(e) => setNameInput(e.target.value)}
            />
          </Box>

          {/* Expense Category Dropdown */}
          <Box sx={{ minWidth: "200px" }}>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 500,
                color: "#000000",
                mb: 0.5,
              }}
            >
              Expense Category
            </Typography>
            <FormControl fullWidth>
              <Select
                value={selectedCategory}
                onChange={(e: SelectChangeEvent<string>) =>
                  handleChange("selectedCategory", e.target.value)
                }
                displayEmpty
                sx={{
                  height: "36px",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: selectedCategory ? "#65748B" : "#65748B",
                  borderRadius: "5px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",

                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#C4C4C4",
                    borderWidth: "1px",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#C4C4C4",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#C4C4C4",
                  },
                  "& .MuiSelect-select": {
                    padding: "9px 12px",
                  },
                }}
                renderValue={(selected) =>
                  selected ? (
                    selected
                  ) : (
                    <span style={{ color: "#65748B" }}>Select Expense</span>
                  )
                }
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 200, // controls scroll height
                      mt: 1, // ensures dropdown appears below
                      overflowY: "auto",
                    },
                  },
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                }}
              >
                <MenuItem disabled value="">
                  <span style={{ fontSize: "12px", color: "#65748B" }}>
                    Select Expense
                  </span>
                </MenuItem>
                {catData?.map((category: any) => (
                  <MenuItem
                    key={category?.id}
                    value={category?.name}
                    sx={{ fontSize: "14px", color: "#181818" }}
                  >
                    {category?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            m: 2,
          }}
        >
          <AppButton
            onClick={handleFilterSearch}
            textTransform={"none"}
            title="Filter"
            style={{ padding: "10px 16px 10px 16px" }}
          />
        </Box>
      </Menu>
    </Box>
  );
};

export default ExpenseFilterModal;
